import React, { useState, useEffect } from "react";
import { useFetch } from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import {columnsDataCurrency} from "../variables/columnsData";
import ColumnsTable from "./ColumnsTable";
import AddCurrencyModal from "./AddCurrencyModal";
import {getMonthNumber} from "../../../../utils/utils";


const CurrencyModal = ({ showModal, setModalState, year, month }) => {
    const fetchWrapper = useFetch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [currency, setCurrency] = useState([]);
    const [addCurrencyModal, setAddCurrencyModal] = useState(false);


    useEffect(() => {
        fetchData();
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    const fetchData = async () => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/exchange-rate?yearMonth=${year}-${getMonthNumber(month)}`;

            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data && responseData.data.length > 0) {
                    setCurrency(responseData.data);
                }
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    };

    const handleCancel = () => {
        setModalState(false);
    }

    const refreshData = () => {
        setCurrency([]);
        fetchData();
    }

    const openAddCurrencyModal = () => {
        setAddCurrencyModal(true);
    }

    const mappedApiData = currency.map((item) => ({
        id: item.id,
        registrationDate: item.registrationDate,
        fromCurrency: item.fromCurrency,
        toCurrency: item.toCurrency,
        exchangeRate: item.exchangeRate
    }));

    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Câmbio</h4>
                                </div>
                                <header className="relative flex items-center justify-between">
                                    <div className="text-xl font-bold text-navy-700 dark:text-white">
                                    </div>
                                    <div className="flex justify-center items-center font-bold text-brand-600 pr-8">
                                        <button onClick={openAddCurrencyModal}>Cadastrar</button>
                                        {/* Conditional rendering of modal */}
                                        {addCurrencyModal && (
                                            <AddCurrencyModal
                                                showModal={addCurrencyModal}
                                                setModalState={setAddCurrencyModal}
                                                refreshData={refreshData}
                                            />
                                        )}
                                    </div>
                                </header>


                                {/* Modal Body */}
                                <div style={{overflowY: "auto", maxHeight: "70vh"}}>
                                        {loading ? (
                                            <div></div>
                                        ) : mappedApiData && mappedApiData.length > 0 ? (
                                            <ColumnsTable
                                                columnsData={columnsDataCurrency}
                                                tableData={mappedApiData}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                    </div>

                                    {/* Modal Footer */}
                                    <div
                                        className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                        <button
                                            onClick={handleCancel}
                                            className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                            </div>
                        </div>
                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default CurrencyModal;
